// 화면 «등록 전송» 뒤 우리 쪽 기록 — 확장이 알려 주는 것은 «서플라이어허브 제출 버튼 뒤 완료 글이 떴다» 뿐이라(허브 WIMS 실제 줄 확인 0)
// registered 를 올리지 않고 «전송됨·확인 전»으로만 적는다(판 #378 · 10-20 유앤채 6건 거짓 등록완료).
// 칸은 도구 길(tool-exec/rocket-submit.js saveSent · #2369)과 같다: 옵션 registrationStatus 'pending' + registerConfirm{status:'not_found'}
// → 도구 isSent 가 «보냄»으로 읽어 다시 보내지 않고, 같은 등록ID 로 submitRegistration 을 부르면 허브만 다시 확인해 그때 등록됨으로 올린다.
export const SENT_UNCONFIRMED = 'not_found'

/** set(obj, key, value) — 화면은 this.$set(반응성), 시험은 그냥 대입 */
// qvtRequestId — 확장이 초안 생성 응답에서 받은 견적 번호(있을 때만). coupangDoc 에 남겨 허브 재확인(utils/hubRecheck quotationIdOf)이 번호로 바로 찾게 한다(딩톡 #46)
export function markSentUnconfirmed(product, docId, set, now = Date.now(), qvtRequestId = null) {
  if (!product) return
  if (product.registered === true && product.registerConfirm && product.registerConfirm.status === 'found') return   // 허브에서 이미 확인됨
  set(product, 'verified', true)   // 쿠팡 검증 단계는 통과
  set(product, 'errorDetails', '')
  set(product, 'registerConfirm', { status: SENT_UNCONFIRMED, at: now, ...(docId ? { docId } : {}) })
  if (docId) {
    if (!product.coupangDoc) set(product, 'coupangDoc', { docId, jsonDocument: [] })
    else set(product.coupangDoc, 'docId', docId)
    if (qvtRequestId) set(product.coupangDoc, 'qvtRequestId', String(qvtRequestId))
  }
  for (const option of (Array.isArray(product.options) ? product.options : [])) {
    set(option, 'verified', true)
    set(option, 'registrationStatus', 'pending')
    set(option, 'errorDetails', '')
  }
}
